import { Wrap, WrapItem, Tag, TagLabel, Tooltip} from '@chakra-ui/react';

interface Person {
  name: string;
  description?: string;
}

interface TagCloudProps {
  tags: (string | Person)[];
  colorScheme?: string;
  showTooltips?: boolean;
}

export const TagCloud = ({ tags, colorScheme = 'blue', showTooltips = false }: TagCloudProps) => {
  const renderTag = (tag: string | Person) => {
    const isPersonObject = typeof tag !== 'string';
    const label = isPersonObject ? tag.name : tag;
    const description = isPersonObject ? tag.description : undefined;

    const tagElement = (
      <Tag
        size="md"
        borderRadius="full"
        variant="subtle"
        colorScheme={colorScheme}
        cursor={description ? "help" : "default"}
        transition="all 0.2s"
        _hover={{
          transform: description ? "translateY(-2px)" : "none",
          shadow: description ? "sm" : "none"
        }}
      >
        <TagLabel>{label}</TagLabel>
      </Tag>
    );

    if (showTooltips && description) {
      return (
        <Tooltip 
          label={description}
          hasArrow
          placement="top"
          bg={`${colorScheme}.700`}
          color="white"
        >
          {tagElement}
        </Tooltip>
      );
    }

    return tagElement;
  };

  return (
    <Wrap spacing={2}>
      {tags.map((tag, index) => (
        <WrapItem key={index}>
          {renderTag(tag)}
        </WrapItem>
      ))}
    </Wrap>
  );
}; 